<template>
  <div class="nft-media-wrapper">
    <img
      class="nft-image"
      v-if="
        nft.file.mimeType.includes('image') || nft.file.mimeType.includes('pdf')
      "
      :src="nftCoverImage"
    />
    <div v-show="nft.file.mimeType.includes('pdf')" class="button-pdf">
      <a :href="nft.file.path" target="_blank">
        <button class="app-modal-button-transparent">Download PDF</button>
      </a>
    </div>
    <img
      class="nft-image-audio"
      v-if="nft.file.mimeType.includes('audio')"
      :src="nftCoverImageAudio"
    />
    <app-audio
      v-if="nft.file.mimeType.includes('audio')"
      :url="nft.file.path"
      class="nft-audio"
    />
    <app-video
      v-if="nft.file.mimeType.includes('video')"
      :url="nft.file.path"
      :type="nft.file.mimeType"
      class="nft-video"
    />
  </div>
</template>

<script>
import { computed } from "vue";
import imageTransformer from "@/plugins/imageTransformer";
import AppAudio from "@/components/AppAudio";
import AppVideo from "@/components/AppVideo";

export default {
  components: {
    AppAudio,
    AppVideo,
  },
  props: {
    nft: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const nftCoverImage = computed(() =>
      imageTransformer.transform(
        props.nft.coverImage.filename,
        "nft.show.image"
      )
    );
    const nftCoverImageAudio = computed(() =>
      imageTransformer.transform(
        props.nft.coverImage.filename,
        "nft.show.audio"
      )
    );
    return {
      nftCoverImage,
      nftCoverImageAudio,
    };
  },
};
</script>

<style lang="scss" scoped src="@/Common/Styles/nftMedia.scss"></style>
